<template>
  <div>
    <div class="popup-wrapper">
      <div class="button-wrapper">
        <span @click="showDeleteModal" v-close-popover>
          <DeleteIcon />
        </span>
        <span @click="showEditModal" v-close-popover>
          <PencilIcon />
        </span>
        <span @click="hideDetailsModal($event, popupEvent.id)">
          <CircleXIcon v-close-popover />
        </span>
      </div>
      <div style="display: flex">
        <div class="photo-wrapper">
          <NoPhotoIcon />
          <span class="info">{{ popupEvent.text }}</span>
        </div>
        <div class="detail-wrapper">
          <div class="content">
            <div>
              <span class="title">Arrival</span>
              <span class="info">{{
                popupEvent.start.format('ddd, MMM DD')
              }}</span>
            </div>
            <div>
              <span class="title">Guests</span>
              <span class="info">{{ popupEvent.companions }} Guest</span>
            </div>
            <div>
              <span class="title">Channel</span>
              <span class="info">{{ popupEvent.channel }}</span>
            </div>
            <div>
              <span class="title">Property</span>
              <span class="info">{{ popupEvent.propertyName }}</span>
            </div>
          </div>
          <div class="content">
            <div>
              <span class="title">Departure</span>
              <span class="info">{{
                popupEvent.end.format('ddd, MMM DD')
              }}</span>
            </div>
            <div>
              <span class="title">Nigths</span>
              <span class="info">{{ totalNights }} Nights</span>
            </div>
            <div>
              <span class="title">Rental Code</span>
              <span class="info">{{ popupEvent.confirmationCode }}</span>
            </div>
            <div>
              <span class="title">Room</span>
              <span class="info">{{ popupEvent.room.internalName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NoPhotoIcon from '../../sharedIcons/NoPhoto.vue'
import DeleteIcon from '../../sharedIcons/Delete.vue'
import PencilIcon from '../../sharedIcons/Pencil.vue'
import CircleXIcon from '../../sharedIcons/CircleX.vue'
import calls from '@/api/calls'

export default {
  props: {
    popupEvent: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      content: {}
    }
  },
  computed: {
    totalNights() {
      return this.popupEvent.end.diff(this.popupEvent.start, 'days')
    }
  },
  methods: {
    showDeleteModal() {
      this.$emit('showDeleteModal')
    },
    async showEditModal() {
      const { data } = await calls.GET('rooms', this.popupEvent.room.uuid)
      let section1 = data.room ? { ...data.room } : { ...data }
      let section2 = {
        arrival: this.popupEvent.start.format('YYYY-MM-DD HH:mm:ss'),
        arrivalOriginal: this.popupEvent.start,
        canceled: this.popupEvent.canceled,
        channel: this.popupEvent.channel,
        confirmationCode: this.popupEvent.confirmationCode,
        departure: this.popupEvent.end.format('YYYY-MM-DD HH:mm:ss'),
        departureOriginal: this.popupEvent.end,
        houseCode: this.popupEvent.houseCode,
        companions: this.popupEvent.companions
      }
      let section3 = {
        ...this.popupEvent.housemate
      }

      let item = [null, section1, section2, section3]

      this.$emit('showEditModal', item)
    },

    hideDetailsModal(e, id) {
      e.stopPropagation()
      this.$emit('hideDetailsModal', id)
    }
  },
  components: {
    DeleteIcon,
    PencilIcon,
    CircleXIcon,
    NoPhotoIcon
  }
}
</script>
<style>
.popup-wrapper {
  width: 370px;
  background: #ffffff;
  font-size: 10px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 10%);
}
.vue-popover-theme {
  z-index: 30;
}

.popup-wrapper .button-wrapper {
  padding-top: 10px;
  padding-right: 10px;
  right: 0;
  text-align: right;
}
.popup-wrapper .button-wrapper span {
  cursor: pointer;
  margin-left: 8px;
}
.popup-wrapper .button-wrapper svg {
  padding-right: 10px;
}
.popup-wrapper .photo-wrapper {
  width: 30%;
  padding: 16px;
  text-align: center;
  border-right: 1px solid rgba(192, 192, 192, 0.3);
  border-top: 1px solid rgba(192, 192, 192, 0.3);
}

.photo-wrapper .info {
  margin-top: -15%;
}
.popup-wrapper .detail-wrapper {
  width: 70%;
  display: flex;
  border-top: 1px solid rgba(192, 192, 192, 0.3);
}

.popup-wrapper .detail-wrapper .content {
  width: 50%;
}

.popup-wrapper .detail-wrapper .content span {
  display: flex;
  margin-left: 20%;
}
.popup-wrapper .title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: -15%;
}
.popup-wrapper .info {
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  color: #000000;
  display: block;
}

.content span {
  line-height: 30px;
}
</style>
